import react from "react";

import Thatch1 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_055 Large.jpeg";
import Thatch2 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_056 Large.jpeg";
import Thatch3 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_057 Large.jpeg";
import Thatch4 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_058 Large.jpeg";
import Thatch5 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_059 Large.jpeg";
import Thatch6 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_060 Large.jpeg";
import Thatch7 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_061 Large.jpeg";
import Thatch8 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_062 Large.jpeg";
import Thatch9 from "../images/commercials/Thatch/KIDSPORTFOLIO_WITHBORDERS_2024_063 Large.jpeg";

const Thatch = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={Thatch1} alt="Thatch Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch2} alt="Thatch Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch3} alt="Thatch Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch4} alt="Thatch Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch5} alt="Thatch Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch6} alt="Thatch Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch7} alt="Thatch Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch8} alt="Thatch Commercial Photography - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={Thatch9} alt="Thatch Commercial Photography - Image 9"/>
                </div>
            </div>
        </div>
    );
}

export default Thatch;